import indexOf from 'lodash/indexOf';
export var compareArray = function (existingArray, targetArray, addCallback, removeCallback) {
    // Process adds
    for (var i = 0; i < targetArray.length; i++) {
        if (indexOf(existingArray, targetArray[i]) === -1) {
            addCallback(targetArray[i]);
        }
    }
    // Process removes
    for (var i = 0; i < existingArray.length; i++) {
        if (indexOf(targetArray, existingArray[i]) === -1) {
            removeCallback(existingArray[i]);
        }
    }
    return false;
};
export default {
    compareArray: compareArray
};
